import Image from 'next/image';
import { useEffect } from 'react';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import useUser from '@alltrails/context/hooks/useUser';
import { BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import BaseUpsellStep from '../BaseUpsell/BaseUpsellStep';
import GenericUpsellContent from '../GenericUpsellContent/GenericUpsellContent';
import getUpsellCtaText from '../getUpsellCtaText';
import { peakUpsellHeading, peakUpsellPromoEligibleHeading } from './GenericPeakUpsell';
import headerImage from './images/route-assistant-web.avif';

type Props = {
  navigateTo: (modalKey: 'checkout') => void;
  onCloseRequest: () => void;
  onSuccess?: () => void;
  upsellTrigger: UpsellTrigger;
};

// The Peak upsell rendered as a step of an existing Plus upsell modal, reached from PeakInfoModule.
export default function GenericPeakUpsellStep({ navigateTo, onCloseRequest, onSuccess, upsellTrigger }: Props) {
  const user = useUser();
  const isPromoEligible = user?.isPromoEligible || false;

  useEffect(() => {
    // Scroll to top in case the user scrolled down in the previous step.
    const modalScrollContainer = document.querySelector('#modal-scroll-container');
    modalScrollContainer?.scrollTo(0, 0);
  }, []);

  return (
    <BaseUpsellStep
      headerImage={<Image alt="" sizes={`(max-width: ${BREAKPOINT_SM_SIZE}px) 100vw, 480px`} src={headerImage} />}
      headerImageV3
      heading={peakUpsellHeading}
      navigateTo={navigateTo}
      onCloseRequest={onCloseRequest}
      onSuccess={onSuccess}
      primaryButtonText={getUpsellCtaText({ tier: 'peak', user })}
      primaryButtonVariant="accent"
      productType="peak"
      productsAvailable="plus-peak"
      promoEligibleHeading={peakUpsellPromoEligibleHeading}
      // The Plus step already logged `upsell shown` for this trigger, and the tap that got here is logged
      // as `upsell product clicked`.
      suppressUpsellShown
      upsellTrigger={upsellTrigger}
    >
      <GenericUpsellContent
        heading={peakUpsellHeading}
        isPromoEligible={isPromoEligible}
        promoEligibleHeading={peakUpsellPromoEligibleHeading}
        tier="peak"
        upsellTrigger={upsellTrigger}
      />
    </BaseUpsellStep>
  );
}
